import { createSlice } from "@reduxjs/toolkit";

let fakeData = [
  {
    id: "reboot-rule-001",
    name: "Weekly AP Reboot",
    enable: true,
    modelNames: ["DAP-X2850"],
    deviceIds: [],
    frequency: "1,3,5",
    time: "03:00",
  },
  {
    id: "reboot-rule-002",
    name: "Nightly Switch Maintenance",
    enable: true,
    modelNames: ["DGS-1210-28"],
    deviceIds: [],
    frequency: "daily",
    time: "02:30",
  },
  {
    id: "reboot-rule-003",
    name: "Weekend Network Refresh",
    enable: false,
    modelNames: ["DGS-1250-28X", "DGS-1210-28"],
    deviceIds: [],
    frequency: "0,6",
    time: "01:00",
  },
  {
    id: "reboot-rule-004",
    name: "Branch Office Reboot",
    enable: true,
    modelNames: ["DAP-3666"],
    deviceIds: [],
    frequency: "daily",
    time: "04:30",
  },
  {
    id: "reboot-rule-005",
    name: "Monthly Infrastructure Restart",
    enable: false,
    modelNames: ["DGS-1210-52MP"],
    deviceIds: [],
    frequency: "0",
    time: "00:30",
  },
];

const initialState = {
  resource: "scheduleReboot",
  data: [...fakeData],
};

export const scheduleRebootSlice = createSlice({
  name: "scheduleReboot",
  initialState,
  reducers: {
    setScheduleRebootData: (state) => {
      state.data = [...fakeData];
    },
    createScheduleReboot: (state, action) => {
      const payload = action.payload.data ?? action.payload;
      const newRule = {
        ...payload,
        id: `reboot-rule-${(fakeData.length + 1).toString().padStart(3, "0")}`,
      };
      fakeData = [...fakeData, newRule];
      state.data = [...fakeData];
    },
    updateScheduleReboot: (state, action) => {
      const payload = action.payload.data ?? action.payload;
      const ruleId = action.payload.scheduleRebootId || payload.id;
      const index = fakeData.findIndex((item) => item.id === ruleId);
      if (index !== -1) {
        fakeData[index] = {
          ...fakeData[index],
          ...payload,
          id: ruleId,
        };
        state.data = [...fakeData];
      }
    },
    deleteScheduleReboot: (state, action) => {
      const payload = action.payload.data ?? action.payload;
      const ids = payload.ids ?? [];
      fakeData = fakeData.filter((item) => !ids.includes(item.id));
      state.data = [...fakeData];
    },
  },
});

export const {
  setScheduleRebootData,
  createScheduleReboot,
  updateScheduleReboot,
  deleteScheduleReboot,
} = scheduleRebootSlice.actions;

export default scheduleRebootSlice.reducer;
